export default __webpack_public_path__ + "static/media/Ies_Panel2_movil.24141324.jpg";